import React from 'react';
import { Calendar } from 'lucide-react';

const BookingTrendChart = ({ trends = [] }) => {
  if (!trends || trends.length === 0) {
    return (
      <div className="rounded-2xl border border-gray-200/80 bg-white dark:border-gray-700 dark:bg-gray-900 shadow-sm p-4 sm:p-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-50 mb-4">Booking Trend</h3>
        <div className="text-center py-12">
          <Calendar className="w-12 h-12 text-gray-400 dark:text-gray-500 mx-auto mb-4" />
          <p className="text-gray-600 dark:text-gray-400">No booking data available</p>
        </div>
      </div>
    );
  }

  const bookingData = trends.map(item => ({
    period: item.period,
    count: Number(item.count || 0)
  }));

  const maxCount = Math.max(...bookingData.map(d => d.count), 1);

  return (
    <div className="rounded-2xl border border-gray-200/80 bg-white dark:border-gray-700 dark:bg-gray-900 shadow-sm p-4 sm:p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-50">Booking Trend</h3>
        <Calendar className="w-5 h-5 text-sky-600 dark:text-sky-400" />
      </div>
      <div className="space-y-3">
        {bookingData.map((item, index) => {
          const percentage = maxCount > 0 ? (item.count / maxCount) * 100 : 0;
          return (
            <div key={index} className="space-y-1">
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600 dark:text-gray-400 font-medium">{item.period}</span>
                <span className="text-gray-900 dark:text-gray-50 font-semibold">{item.count} bookings</span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2.5">
                <div
                  className="bg-gradient-to-r from-sky-500 to-sky-600 h-2.5 rounded-full transition-all duration-500"
                  style={{ width: `${percentage}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600 dark:text-gray-400">Total</span>
          <span className="text-lg font-bold text-gray-900 dark:text-gray-50">
            {bookingData.reduce((sum, item) => sum + item.count, 0)} bookings
          </span>
        </div>
      </div>
    </div>
  );
};

export default BookingTrendChart;
